/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import { Copy, Title, BodyCopy, Switch, Icon } from '@insticator/insticator-ui'; // iui-material
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/embeds/management/ads/videoads/videoads_styles';



/* ========== ~~~~~~~~~~ EMBED VIDEO ADs ~~~~~~~~~~ ========== */
const VideoAds = (props) => {
    const handleToggle = (toggleDevice) => {
        props.setVideoAds(toggleDevice, !props.videoAdsStatus[toggleDevice]);
    };
	const checkToggleStatus = (deviceToToggle) => {
        return props.videoAdsStatus[deviceToToggle] ? 'on' : 'off';
    };
    return(
        <div className={`videoads ${props.classes.videoads}`}>
        	<div className={`videographic`}>
        		<Icon name={`play-circle`} />
        	</div>
        	<Copy>
                <Title>
                    <h2>Run Video Ads</h2>
                </Title>
                <BodyCopy>
                    <p>Run video ads underneath your embed on desktop and mobile to drive higher CPMs.</p>
                </BodyCopy>
            </Copy>
            <div className={`selections`}>
            	<div className={`selection desktop`}>
            		<span className={`container imagery`}><Icon name={`desktop`} /></span>
            		<span className={`container desc`}><span className={`devicename`}>Desktop</span></span>
            		<span className={`container cta`}><Switch handleClick={() => handleToggle('desktop')} value={`desktopvideoad`} on={checkToggleStatus('desktop')} variant={'secondary'} /></span>
            	</div>
            	<div className={`selection mobile`}>
            		<span className={`container imagery`}><Icon name={`mobile-alt`} /></span>
            		<span className={`container desc`}><span className={`devicename`}>Mobile</span></span>
            		<span className={`container cta`}><Switch handleClick={() => handleToggle('mobile')} value={`mobilevideoad`} on={checkToggleStatus('mobile')} variant={'secondary'} /></span>
            	</div>
            </div>
        </div>
    );
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(VideoAds);
